import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_patient')({
  component: PatientLayout,
});

function PatientLayout() {
  return (
    <Outlet />
  );
}
